import { render, staticRenderFns } from "./wcrd_reg_frms.vue?vue&type=template&id=2e1f4d12&scoped=true&"
import script from "./wcrd_reg_frms.vue?vue&type=script&lang=js&"
export * from "./wcrd_reg_frms.vue?vue&type=script&lang=js&"
import style0 from "./wcrd_reg_frms.vue?vue&type=style&index=0&id=2e1f4d12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f4d12",
  null
  
)

export default component.exports